// Everything on a claim, kept live (anyone's change reloads it quietly).
import { useCallback, useEffect, useMemo, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { useLive, debounce } from '../../lib/live';
import { loadClaim } from '../../lib/claimData';

export type LoadedClaim = Awaited<ReturnType<typeof loadClaim>>;

export function useClaim(itemId: string) {
  const [data, setData] = useState<LoadedClaim | null>(null);
  const [error, setError] = useState<string | null>(null);
  const load = useCallback(async () => {
    try {
      setData(await loadClaim(supabase, itemId));
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  }, [itemId]);
  useEffect(() => {
    setData(null);
    void load();
  }, [load]);
  const quiet = useMemo(() => debounce(() => void load(), 300), [load]);
  useLive(['claim_details', 'claim_lines', 'claim_variations', 'claim_signatures'], quiet, { filter: `item_id=eq.${itemId}` });
  useLive(['contracts'], quiet);
  return { data, error, reload: load };
}
